import { BASE_PATH_ANALYTICS, BUTTONS_ANALYTICS } from '@/constants/analytics'
import { UnrecoverableEventConfig } from '@/pages/UnrecoverableError/types'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'

type UnrecoverableErrorAnalyticsConfig = Partial<UnrecoverableEventConfig> & {
  errorCode: string
}

const eventConfigDispatcher = ({
  errorCode,
  activity,
  screenPath,
}: UnrecoverableErrorAnalyticsConfig): EventDispatcherConfig => ({
  config: {
    activity,
    screenName: 'UnrecoverableError',
    screenPath: screenPath ?? BASE_PATH_ANALYTICS.PORTAL_OOBE,
  },
  defaultData: {
    actionAuxParams: new URLSearchParams({ errorCode }),
  },
})

export const UnrecoverableErrorPageAnalytics = createAnalyticsManifest(
  eventConfigDispatcher,
  ({ dispatcher }) => ({
    fireExitSetupButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.EXIT_SETUP,
      })
    },
  }),
)
